import {Injectable, signal} from '@angular/core';

const LS_KEY = 'mockToolbarVisible';

@Injectable({ providedIn: 'root' })
export class MockToolbarService {
    readonly visible = signal(localStorage.getItem(LS_KEY) !== 'false');

    hide(): void {
        localStorage.setItem(LS_KEY, 'false');
        this.visible.set(false);
    }

    show(): void {
        localStorage.setItem(LS_KEY, 'true');
        this.visible.set(true);
    }
}
